<div class="actions">
  <ui-button (clicked)="addToCart.emit()" [disabled]="selectedLength() <= 0" buttonStyle="filled">
    @if (isMobile()) {
      zum Warenkorb ({{ selectedLength() }})
    } @else {
      zum Warenkorb hinzufügen ({{ selectedLength() }})
    }
  </ui-button>
  <ui-button (clicked)="removeItems.emit()" [disabled]="selectedLength() <= 0" buttonStyle="outlined">
    Artikel löschen ({{ selectedLength() }})
  </ui-button>
</div>
